module.exports = __webpack_public_path__ + "static/img/img_logo_10.256f01c8.png";